import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../ModuleSubtopic";

// Hardcoded fallback subtopics for SE when state is unavailable
const ALL_SE_SUBTOPICS = [
    { name: 'Nature of Software, Software Engineering, Software process, project, product', path: '/se-m1-s1' },
    { name: 'Process Models, Classical Evolutionary models', path: '/se-m1-s2' },
    { name: 'Agile Process - Extreme programming (XP), Principles of Agile Software Development framework, Overview of System Engineering', path: '/se-m1-s3' },
    { name: 'Planning, Scope, Work break-down structure, Milestones, Deliverables', path: '/se-m2-s1' },
    { name: 'Cost and Estimates - (Human Resources, Time-scale, Costs)', path: '/se-m2-s2' },
    { name: 'Risk Management, RMMM Plan, Case Tools', path: '/se-m2-s3' },
    { name: 'Software Requirements', path: '/se-m3-s1' },
    { name: 'System Modelling', path: '/se-m3-s2' },
    { name: 'Design concepts and principles - Abstraction - Refinement - Modularity - Cohesion - Coupling', path: '/se-m4-s1' },
    { name: 'Architectural design, Detailed Design, Transaction Transformation, Refactoring of designs', path: '/se-m4-s2' },
    { name: 'Object oriented Design, User-Interface Design', path: '/se-m4-s3' },
    { name: 'Strategic Approach to Software Testing', path: '/se-m5-s1' },
    { name: 'Cyclomatic Complexity', path: '/se-m5-s2' },
    { name: 'Regression Testing, Mutation Testing, Object Oriented Testing, Web and Mobile App Testing, DevOps, Cloud and Big Data Testing', path: '/se-m5-s3' }

];

const SEModuleSubtopic = ({ title, videos, takeaways, questions, exampleVideos }) => {
    const location = useLocation();
    const { subtopics = ALL_SE_SUBTOPICS, subjectPath = '/subject-SEModules' } = location.state || {};

    return (
        <ModuleSubtopic
            title={title}
            videos={videos}
            takeaways={takeaways}
            questions={questions}
            exampleVideos={exampleVideos}
            subtopics={subtopics || ALL_SE_SUBTOPICS}
            subjectPath={subjectPath}
        />
    );
};

export default SEModuleSubtopic;
